import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=6d75affe&lang=css"
import "./Popover.vue?vue&type=style&index=1&id=6d75affe&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d75affe"]])

export default __exports__